const MAX_NESTED_LOGIN_REDIRECT_DEPTH = 4;

export function normalizeLoginRedirect(raw: string | null | undefined): string {
  if (!raw) return '';

  let value = raw.trim();
  if (!value) return '';

  try {
    value = decodeURIComponent(value);
  } catch {
    // URLSearchParams may have decoded the first layer already.
  }

  if (!value.startsWith('/') || value.startsWith('//') || /^[a-z][a-z0-9+.-]*:/i.test(value)) {
    return '';
  }

  return value;
}

export function extractEmailFromLoginRedirect(
  rawRedirect: string | null | undefined,
  origin = 'https://app.local',
): string {
  let current = normalizeLoginRedirect(rawRedirect);

  for (let depth = 0; current && depth < MAX_NESTED_LOGIN_REDIRECT_DEPTH; depth += 1) {
    try {
      const url = new URL(current, origin);
      const email = url.searchParams.get('email')?.trim();
      if (email && email.includes('@')) return email;

      const nested = normalizeLoginRedirect(url.searchParams.get('redirect'));
      if (!nested || nested === current) return '';
      current = nested;
    } catch {
      return '';
    }
  }

  return '';
}
